module.exports = __webpack_public_path__ + "img/download-icon.f42b6cff.svg";